<p-dialog
  header="Αλλαγή κωδικού χρήστη"
  [(visible)]="visible"
  [style]="{ width: '90vw', maxWidth: '700px' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!forceChange"
>
  <p-messages [enableService]="false" [closable]="false"></p-messages>

  <p-messages severity="info">
    <ng-template pTemplate>
      <div>
        <p class="m-0">
          Ο κωδικός πρόσβασης πρέπει να συμβαδίζει με τους ακόλουθους κανόνες:
        </p>
        <ul class="pl-2 ml-4 mt-0" style="line-height: 1.5">
          <li>Μήκους τουλάχιστον 8 χαρακτήρες</li>
          <li>Τουλάχιστον 1 σύμβολο (π.χ. $&#64;!%*#?&)</li>
          <li>Τουλάχιστον 1 νούμερο</li>
          <li>Τουλάχιστον 1 κεφαλαίο λατινικό χαρακτήρα (A-Z)</li>
          <li>Τουλάχιστον 1 πεζό λατινικό χαρακτήρα (a-z)</li>
        </ul>
      </div>
    </ng-template>
  </p-messages>

  <eo-form
    #eoForm
    [config]="formConfig"
    [validate]="true"
    class="p-fluid"
    [submitButtonVisible]="false"
  ></eo-form>

  <ng-template pTemplate="footer">
    <div
      class="flex justify-content-end pt-4"
      style="border-top: 1px solid var(--surface-100)"
    >
      <p-button
        *ngIf="!forceChange"
        type="button"
        icon="pi pi-times"
        label="Άκυρο"
        styleClass="p-button-outlined p-button-info mr-2"
        (onClick)="hide()"
      ></p-button>

      <p-button
        *ngIf="forceChange"
        type="button"
        icon="pi pi-sign-out"
        label="Έξοδος"
        styleClass="p-button-danger p-button-outlined mr-2"
        (onClick)="onExitClick()"
      ></p-button>

      <p-button
        type="button"
        icon="pi pi-save"
        [label]="submitLabel"
        styleClass="p-button-primary"
        (onClick)="onSaveClick()"
        [disabled]="eoForm?.getForm()?.invalid || isLoading()"
        [loading]="isLoading()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
